import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";

export default function (element, dataset) {
  const desktop = window.matchMedia("(min-width: 991px)");

  const onClick = () => element.classList.toggle("is-open");
  const onEnter = () => element.classList.add("is-open");
  const onLeave = () => element.classList.remove("is-open");

  function bind(isDesktop) {
    if (isDesktop) {
      element.removeEventListener("click", onClick);
      element.addEventListener("mouseenter", onEnter);
      element.addEventListener("mouseleave", onLeave);
    } else {
      element.removeEventListener("mouseenter", onEnter);
      element.removeEventListener("mouseleave", onLeave);
      element.classList.remove("is-open");
      element.addEventListener("click", onClick);
    }
  }

  bind(desktop.matches);

  const onMQChange = (e) => bind(e.matches);
  desktop.addEventListener("change", onMQChange);

  onDestroy(() => {
    element.removeEventListener("click", onClick);
    element.removeEventListener("mouseenter", onEnter);
    element.removeEventListener("mouseleave", onLeave);
    desktop.removeEventListener("change", onMQChange);
  });
}
